import store from "../store/index";

export const ApiUrl = (endPoint, unauthorized) => {
 
    return 'https://api.byu.edu/lifesciences/internshipfellowship/v1.0.0/' + endPoint //url
}

export const fileApiUrl = (endPoint) => {
  let url = "https://lsif-api-dev.byu.edu/api/";
  if (location.hostname.toLocaleLowerCase() === 'lsif.byu.edu')
    url = "https://lsif-api.byu.edu/api/";
  if (endPoint) 
    url = url + endPoint;
  return url;

}

export const makeHeader = (reqBody, reqMethod) => {
  let req = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  if (store.state.AuthToken) {
    req.headers["Authorization"] = "Bearer " + store.state.AuthToken;
  }

  if (reqBody) req.body = JSON.stringify(reqBody);
  if (reqMethod) req.method = reqMethod;

  return req;
};

/**
 *
 * @param {FormData} files - to be uploaded
 * @param {number} applicationId - Application Identifier
 * @returns
 */
export const uploadFiles = async (files, applicationId) => {
  try {
    const data = await fetch(fileApiUrl(`FileUploads/resume/${applicationId}`), {
      headers: { Authorization: "Bearer " + store.state.AuthToken },
      method: "POST",
      body: files,
    });
    if (data.status > 299) handleErr(data);
    else if (data.status === 204) return;
    return await data.json();
  } catch (err) {
    handleErr(err);
  }
};

export const fileRootUrl = (endpoint) => {
  let url = "C:/inetpub/wwwroot/fellowship-files";
  if (process.env.NODE_ENV != "development") {
    url = "https://lsif-files.byu.edu/";
  }
  return url;
};

export const handleErr = (err) => {
  try {
    err.text().then((msg) => {
      console.log(err);
      let txt =
        "An Error Occurred while processing the request. If the error persists please contact tech support at <a href='mailto:lfsci-webteam@byu.edu'>lfsci-webteam@byu.edu</a>.";
      // if (msg)
      //     txt += "<br /><br />The full error message was: " + msg
      if (err.status === 401) {
        txt = "Your session has timed out, please login again to continue";
      }
      store.commit("setError", { message: txt, status: err.status });
      return;
    });
  } catch (e) {
    console.warn(e, err);
  }
};

export const APICall = async (endpoint, method, body, unauthorized) => {
  const response = await fetch(
    ApiUrl(endpoint, unauthorized),
    makeHeader(body, method)
  );
  if (!response.ok) {
    handleErr(response);
    return Promise.reject(response);
  }
  if (response.status == 204) return await response.text();
  return await response.json();
};

export const getRoles = () => APICall("users/roles");
export const getUsers = () => APICall("users");
export const getUserByNetId = (netId) => APICall(`users/netid/${netId}`);
export const postUser = (data) => APICall("users", "POST", data);
export const putUser = (data) => APICall("users/" + data.id, "PUT", data);
export const deleteUser = (id) => APICall("users/" + id, "DELETE");

export const getInternships = () => APICall("internships");
export const postInternship = (data) => APICall("internships", "POST", data);
export const putInternship = (data) =>
  APICall("internships/" + data.id, "PUT", data);
export const deleteInternship = (id) => APICall("internships/" + id, "DELETE");
export const getApplications = () => APICall("applications");

export const uploadFile = (data) => APICall("files", "POST", data, true); // when doing file uploads we don't go through the "authorized" url
export const uploadApplication = (data) =>
  APICall("applications", "POST", data);
export const getApplicationByNetId = (netId) =>
  APICall(`applications/netid/${netId}`);
export const getApplicationById = (id) => APICall(`applications/${id}`);
export const getProfessorApplicationByNetId = (id) =>
  APICall(`applications/user/${id}`);
export const updateApplication = (data) =>
  APICall(`applications/${data.id}`, "PUT", data);

export const makeFail = () => {
  const p = new Promise(function(resolve, reject) {
    reject({
      status: 456,
      url: "https://api.byu.edu/lifesciences/api/some/endpoint",
      statusText: "I failed :/",
      text: function() {
        return Promise.resolve("I failed :/");
      },
    });
  });

  return p;
};

export const getSubmissions = () => APICall("submissions");
